module.exports = __webpack_public_path__ + "img/11.c24f80d7.gif";